var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiRrEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6083_5221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 0.999832H5C3.67441 1.00142 2.40356 1.52871 1.46622 2.46605C0.528882 3.40339 0.00158786 4.67424 0 5.99983L0 17.9998C0.00158786 19.3254 0.528882 20.5963 1.46622 21.5336C2.40356 22.471 3.67441 22.9982 5 22.9998H19C20.3256 22.9982 21.5964 22.471 22.5338 21.5336C23.4711 20.5963 23.9984 19.3254 24 17.9998V5.99983C23.9984 4.67424 23.4711 3.40339 22.5338 2.46605C21.5964 1.52871 20.3256 1.00142 19 0.999832ZM5 2.99983H19C19.5988 3.00101 20.1835 3.18135 20.679 3.51764C21.1744 3.85393 21.5579 4.33078 21.78 4.88683L14.122 12.5458C13.5584 13.1071 12.7954 13.4223 12 13.4223C11.2046 13.4223 10.4416 13.1071 9.878 12.5458L2.22 4.88683C2.44215 4.33078 2.82561 3.85393 3.32105 3.51764C3.81648 3.18135 4.40121 3.00101 5 2.99983ZM19 20.9998H5C4.20435 20.9998 3.44129 20.6838 2.87868 20.1212C2.31607 19.5585 2 18.7955 2 17.9998V7.49983L8.464 13.9598C9.40263 14.8961 10.6743 15.4219 12 15.4219C13.3257 15.4219 14.5974 14.8961 15.536 13.9598L22 7.49983V17.9998C22 18.7955 21.6839 19.5585 21.1213 20.1212C20.5587 20.6838 19.7956 20.9998 19 20.9998Z",
    fill: "#314064"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6083_5221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrEnvelope);
export default __webpack_public_path__ + "static/media/fi-rr-envelope.9e6371a497503e65db646d6e2abe0ce1.svg";
export { ForwardRef as ReactComponent };